import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { withTranslation } from "react-i18next";
import { Row, Col, Card, CardBody, Form, FormGroup, Label, Input, Button } from "reactstrap";
import { Link, useHistory, useParams } from "react-router-dom";
import Breadcrumbs from "components/Common/Breadcrumb";
import { ServiceCategoryRequestApi } from "apis/ServiceCategoryRequestApi";
import Swal from "../../helpers/swal_helper";
function EditServiceCategoryRequests(props) {
    const history = useHistory();
    const { id } = useParams();
    const [name, setName] = useState("");
    const [status, setStatus] = useState(1);
    const [loading, setLoading] = useState(false);
    const [fetchLoading, setFetchLoading] = useState(true);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        fetchCategoryDetails();
    }, [id]);

    const fetchCategoryDetails = () => {
        setFetchLoading(true);
        ServiceCategoryRequestApi.getServiceCategoryRequestDetails(id)
            .then((res) => {
                if (res.data.status) {
                    const categoryData = res.data.data;
                    setName(categoryData.request_category_names);
                    setStatus(categoryData.status);
                } else {
                    Swal.fire({
                        title: "Error",
                        text: res.data.message,
                        icon: "error",
                    }).then(() => {
                        history.push("/service-category-requests");
                    });
                }
                setFetchLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setFetchLoading(false);
                Swal.fire({
                    title: "Error",
                    text: "Failed to fetch category details",
                    icon: "error",
                }).then(() => {
                    history.push("/service-category-requests");
                });
            });
    };

    const validateForm = () => {
        let tempErrors = {};
        if (!name.trim()) tempErrors.name = props.t("Name is required");
        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true);
            const formData = new FormData();
            formData.append('id', id);
            formData.append('name', name);
            formData.append('status', status);
          
            ServiceCategoryRequestApi.updateServiceCategoryRequestStatus(formData)
                .then((res) => {
                    setLoading(false);
                    if (res.data.status) {
                        Swal.fire({
                            title: "Success",
                            text: res.data.message,
                            icon: "success",
                        }).then(() => {
                            history.push("/service-category-requests");
                        });
                    } else {
                        Swal.fire({
                            title: "Error",
                            text: res.data.message,
                            icon: "error",
                        });
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    console.log(err);
                    Swal.fire({
                        title: "Error",
                        text: err.response.data.message || "Failed to update category",
                        icon: "error",
                    });
                });
        }
    };

    //meta title
    document.title = props.t("Edit Request Category") + " | " + props.t("Salon");

    if (fetchLoading) {
        return (
            <div className="page-content">
                <div className="container-fluid">
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="sr-only">{props.t("Loading...")}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="page-content">
            <div className="container-fluid">
                <Breadcrumbs title={props.t("Edit Request Categories")} breadcrumbItem={props.t("Edit Request Category")} />

                <Row>
                    <Col xl={12}>
                        <Card>
                            <CardBody>
                                <Form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col md={6}>
                                            <FormGroup>
                                                <Label htmlFor="name">{props.t("Request Category Name")}</Label>
                                                <Input
                                                    type="text"
                                                    id="name"
                                                    placeholder={props.t("Enter category name")}
                                                    value={name}
                                                    onChange={(e) => setName(e.target.value)}
                                                    invalid={!!errors.name}
                                                />
                                                {errors.name && (
                                                    <div className="invalid-feedback">{errors.name}</div>
                                                )}
                                            </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                            <FormGroup>
                                                <Label htmlFor="status">{props.t("Status")}</Label>
                                                <Input
                                                    type="select"
                                                    value={status}
                                                    onChange={(e) => setStatus(e.target.value)}
                                                    style={{ height: "38px", width: "100%" }}
                                                >
                                                    <option value={"pending"}>{props.t("Pending")}</option>
                                                    <option value={"completed"}>{props.t("Completed")}</option>
                                                    <option value={"rejected"}>{props.t("Rejected")}</option>
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <div className="d-flex flex-wrap gap-2">
                                        <Button type="submit" color="primary" disabled={loading}>
                                            {loading ? props.t("Updating...") : props.t("Update")}
                                        </Button>
                                        <Link to="/service-category-requests" className="btn btn-secondary">
                                            {props.t("Cancel")}
                                        </Link>
                                    </div>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </div>
    );
}

EditServiceCategoryRequests.propTypes = {
    t: PropTypes.any,
};

export default withTranslation()(EditServiceCategoryRequests); 